import React, { useContext, useState } from "react";
import axios from "axios";
import {
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
} from "@mui/material";
import AuthContext from "../../contexts/Islogin";

const VerifyAddress = () => {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowLoading, setRowLoading] = useState({}); // key: `${id}_accept` or `${id}_reject`

  const { url } = useContext(AuthContext);

  const fetchWithdrawals = () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");

    axios
      .get(`${url}api/v1/admin/withdrawals`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleVerify = () => {
    setResponse([]);
    fetchWithdrawals();
  };

  const handleActionClick = (item, type) => {
    const token = localStorage.getItem("token");
    const loadingKey = `${item.id}_${type}`;

    setRowLoading((prev) => ({ ...prev, [loadingKey]: true }));

    axios
      .post(`${url}api/v1/admin/withdrawals/${item.id}/${type}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(`${type.toUpperCase()} موفق:`, res.data);
      })
      .catch((err) => {
        console.error(`${type.toUpperCase()} خطا:`, err);
        alert(`خطایی در انجام عملیات ${type} رخ داد.`);
      })
      .finally(() => {
        setRowLoading((prev) => ({ ...prev, [loadingKey]: false }));
        fetchWithdrawals(); // ✅ در هر حالت refetch کن
      });
  };

  const filteredData =
    statusFilter === "all"
      ? response
      : response.filter((item) => item.status === statusFilter);

  return (
    <Paper elevation={3} sx={{ p: 3, width: "80%", mx: "auto", mt: 5 }}>
      <Typography
        variant="h6"
        gutterBottom
        dir="rtl"
        sx={{ textAlign: "right" }}
      >
        تأیید اعتبار آدرس TRX
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" justifyContent="center" gap="2rem" alignItems="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleVerify}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "دریافت اطلاعات"
            )}
          </Button>

          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            size="small"
          >
            <MenuItem value="all">همه وضعیت‌ها</MenuItem>
            <MenuItem value="pending">در انتظار</MenuItem>
            <MenuItem value="accept">تأیید شده</MenuItem>
            <MenuItem value="failed">ناموفق</MenuItem>
            <MenuItem value="canceled">لغو شده</MenuItem>
          </Select>
        </Box>

        {filteredData.length > 0 && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">شناسه</TableCell>
                  <TableCell align="center">آیدی کاربر</TableCell>
                  <TableCell align="center">آدرس مقصد</TableCell>
                  <TableCell align="center">مقدار</TableCell>
                  <TableCell align="center">وضعیت</TableCell>
                  <TableCell align="center">زمان</TableCell>
                  <TableCell align="center">اکشن</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell align="center">{item.id}</TableCell>
                    <TableCell align="center">{item.user_id}</TableCell>
                    <TableCell align="center">{item.toAddress}</TableCell>
                    <TableCell align="center">{item.amount}</TableCell>
                    <TableCell align="center">{item.status}</TableCell>
                    <TableCell align="center">
                      {new Date(item.created_at).toLocaleString("fa-IR")}
                    </TableCell>
                    <TableCell align="center">
                      {item.status === "pending" ? (
                        <Box display="flex" justifyContent="center" gap={1}>
                          <Button
                            size="small"
                            variant="outlined"
                            color="success"
                            onClick={() => handleActionClick(item, "accept")}
                            disabled={rowLoading[`${item.id}_accept`]}
                          >
                            {rowLoading[`${item.id}_accept`] ? (
                              <CircularProgress size={18} color="inherit" />
                            ) : (
                              "تأیید"
                            )}
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => handleActionClick(item, "reject")}
                            disabled={rowLoading[`${item.id}_reject`]}
                          >
                            {rowLoading[`${item.id}_reject`] ? (
                              <CircularProgress size={18} color="inherit" />
                            ) : (
                              "رد"
                            )}
                          </Button>
                        </Box>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default VerifyAddress;
